<div class="clr"></div>
<div *ngIf="showMessage" class="marquee">
    <div class="marquee-content">
      {{ messagescroll }}
    </div>
</div>
  
<div *ngIf="showProgressBaralert">
    <div class="lmask"></div>
</div>
<mat-label *ngIf="nopsid">
    <div class="noResult">There is no active alert for this power supply</div>
    <br>
</mat-label>
<div *ngIf="showcount" class="subResult">
    <mat-toolbar class="mat-toolbar listps fontPS" color="accent" style="color:#000;">
        <div *ngIf="alertResult.totalRecordsCount != 0" style="width: 100%;font-weight:bold;">
            <i class="fa fa-book icon" aria-hidden="true"></i> &nbsp;Alerts/Events
            History({{alertResult.totalRecordsCount}}
            {{ alertResult.totalRecordsCount == 1 ? 'Result' : 'Results' }})
        </div>
        <div *ngIf="alertResult.totalRecordsCount == 0" style="width: 100%;">
            Alerts/Events History
        </div>
    </mat-toolbar>
    <div class="p10"></div>
    <mat-label *ngIf="alertResult.totalRecordsCount == 0">
        <div class="noResult">There is no active alert for this power supply {{psname}}</div>
        <br>
    </mat-label>
    <div class="wrapper">
        <mat-nav-list>
            <div *ngIf="showProgressBaralert">
                <div class="lmask"></div>
            </div>
            <div *ngFor="let activealerts of alertResult.psAlertsList">
                <p mat-list-item><b>Power Supply Name:
                    </b>{{activealerts.powerSupplyName != null ? activealerts.powerSupplyName : '-' }}
                </p>
                <p mat-list-item><b>IP Address:
                    </b>{{activealerts.ip != null ? activealerts.ip : '-' }}
                </p>
                <p mat-list-item><b>Mac Address:
                    </b>{{activealerts.macAddress != null ? activealerts.macAddress : '-' }}
                </p>
                <p mat-list-item><b>Alert Start Time:
                    </b>{{activealerts.alertStartTime != null ? activealerts.alertStartTime : '-' }}
                </p>
                <p mat-list-item><b>Alert Duration:
                    </b>{{activealerts.alertDuration != null ? activealerts.alertDuration : '-' }}
                </p>
                <p mat-list-item><b>Alert Type:
                    </b>{{activealerts.alertDesc != null ? activealerts.alertDesc : '-' }}
                </p>
                <p mat-list-item><b>Alert Description:
                    </b>{{activealerts.alertDetails != null ? activealerts.alertDetails : '-' }}
                </p>
                <p mat-list-item><b>Alert Level:
                    </b>{{activealerts.alertLevel != null ? activealerts.alertLevel : '-' }}
                </p>
                <p mat-list-item *ngIf="activealerts.totalCustomersOffline && activealerts.totalCustomers"><b>Customers
                        Offline: </b>{{activealerts.totalCustomersOffline + '/' + activealerts.totalCustomers}}
                </p>
                <p mat-list-item><b>Impacted Devices:
                    </b>{{activealerts.impactedDevices != null ? activealerts.impactedDevices : '-' }}
                </p>
                <p mat-list-item><b>PS State: </b>{{activealerts.psState == null ? '-' : (activealerts.psState == 'on_battery' ? 'on_standby' : activealerts.psState) }}</p>
                <p mat-list-item *ngIf="activealerts.psExpectedFailureTime"><b>Expected Failure Time: </b>{{ activealerts.psExpectedFailureTime }}</p>
                <p mat-list-item *ngIf="activealerts.batteryTimeMinsRemaining"><b>Battery Runtime Remaining: </b>{{ activealerts.batteryTimeMinsRemaining }} Mins</p>
                <p mat-list-item><b>Network Impact:
                    </b>{{activealerts.networkImpact != null ? activealerts.networkImpact : '-' }}
                </p>
                <p mat-list-item><b>CMTS: </b>{{activealerts.cmts != null ? activealerts.cmts : '-' }}</p>
                <p mat-list-item><b>Primary Node: </b>{{activealerts.ncpnode != null ? activealerts.ncpnode : '-' }}</p>
                <!--<p mat-list-item><b>Hierarchy Path: </b>{{activealerts.hierarchyPathLabels != null ? activealerts.hierarchyPathLabels : '-' }}</p>-->
                <p mat-list-item><b>Current Score:
                    </b>{{activealerts.psScoreCurrent != null ? activealerts.psScoreCurrent : '-' }}
                </p>
                <!-- <p mat-list-item><b>Alert Score:
                    </b>{{activealerts.psScoreAlert != null ? activealerts.psScoreAlert : '-' }}
                </p> -->
                <div class="block_line" color="accent"></div>
            </div><br>
        </mat-nav-list>
    </div>
</div>
